var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-separator",class:_vm.bem('inline-separator', { color: _vm.color })},[_vm._v(" • ")])}
var staticRenderFns = []

export { render, staticRenderFns }